import { useState } from 'react';

const faqs = [
  {
    question: 'Are they sold separately?',
    answer: 'No. Sold exclusively as a complete set.',
  },
  {
    question: 'Do I need the HOME?',
    answer: 'Not at all. Stands completely on its own.',
  },
  {
    question: 'Is this digital?',
    answer: 'Physical only, printed and shipped to you.',
  },
  {
    question: 'Can therapists use the cards?',
    answer: 'Yes. Contact team for bulk orders.',
  },
  {
    question: 'Can I gift this?',
    answer: 'Yes. Add a gift message at checkout.',
  },
  {
    question: 'Where do you ship?',
    answer: 'Currently shipping within the United States. International shipping coming soon.',
  },
  {
    question: 'Return policy?',
    answer: 'Returns accepted within 14 days of delivery. Items must be unopened and in original condition.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-[#FDFAF8] py-16 md:py-28 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-3xl mx-auto">
        {/* Headline */}
        <h2 className="font-heading text-xl md:text-3xl text-[#1A1A1A] text-center mb-12">
          Frequently Asked Questions
        </h2>

        {/* Accordion */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={faq.question}
              className="border border-[#C9A84C]/20 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex items-center justify-between p-4 md:p-6 text-left bg-[#FDFAF8] hover:bg-[#C9A84C]/10 transition-colors"
              >
                <span className="font-body text-sm md:text-base font-medium text-[#1A1A1A] pr-4">
                  {faq.question}
                </span>
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-[#C9A84C] text-xl transition-transform`}
                  />
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-40' : 'max-h-0'
                }`}
              >
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <p className="font-body text-sm text-[#4A4A4A] leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}